<template>
  <div>
    <vs-card>
      <div slot="header">
        <h3>Filtrele</h3>
      </div>

      <vs-divider />
      <div>
        <b-row class="justify-content-md-start">
          <b-col lg="2" sm="5">
            <v-select v-model="secilenSatis" :options="satisList" label="name" placeholder="Satış" style="">
            </v-select>
          </b-col>
          <b-col lg="2" sm="5">
            <v-select v-model="secilenTermin" :options="terminList" label="name" placeholder="Termin" style="">
            </v-select>
          </b-col>
          <!--
          <b-col lg="2" sm="5">
            <vue-autosuggest
              v-model="query"
              style="width: 100%"
              :suggestions="filteredOptions"
              :get-suggestion-value="getSuggestionValue"
              :input-props="{
                id: 'autosuggest__input',
                class: 'form-control',
                placeholder: 'Cari Adı'
              }"
              @input="onInputChange"
            >
              <template slot-scope="{ suggestion }">
                <div class="d-flex align-items-center my-suggestion-item">
                  <div class="detail ml-50 my-suggestion-item">
                    <b-card-text class="mb-0">
                      {{ suggestion.item.ACTNAME }}
                    </b-card-text>
                  </div>
                </div>
              </template>
</vue-autosuggest>
</b-col>-->
          <b-col cols="4" md="auto" style="padding-left: 0px !important;">
            <vs-button style="border-radius: 5px; width: 100%" type="gradient" id="button-with-loading-yeni"
              class="vs-con-loading__container" size="" @click="getPlanlamaList()">Listele</vs-button>
          </b-col>

          <b-col cols="1" style="padding-left: 0px !important;">
            <b-dropdown variant="danger" size="sm" text="İşlemYap" style="height: 100% !important">
              <b-dropdown-item @click="
                secimText = 'Teklif';
              onayla();
              ">Teklif Ekle</b-dropdown-item>
              <b-dropdown-item @click="
                secimText = 'Siparis';
              onayla();
              ">Sipariş Ekle</b-dropdown-item>
            </b-dropdown>
          </b-col>
          <b-col cols="4" md="auto" style="padding-left: 0px !important;">
            <vs-button style="border-radius: 5px; width: 100%" type="gradient" size="" color="warning"
              @click="mailGonder()">Mail
              Gönder</vs-button>
          </b-col>
          <b-col cols="4" md="auto" style="padding-left: 0px !important;">
            <vs-button style="border-radius: 5px; width: 100%" type="gradient" id="button-with-loading-yeni"
              class="vs-con-loading__container" size="" @click="refreshData()">Yenile</vs-button>
          </b-col>
        </b-row>
      </div>
    </vs-card>
    <vs-card>
      <div class="test-header">
        <label style="    margin-right: 10px;">
          <vs-radio v-on:change="externalFilterChanged('everyone')" vs-name="radios1" vs-value="luis">Tümü</vs-radio>
        </label>

        <label style="    margin-right: 10px;">
          <vs-radio v-on:change="externalFilterChanged('sonuc')" vs-name="radios1" vs-value="luis">İhtiyaç
            olanlar</vs-radio>
        </label>

        <label style="    margin-right: 10px;">
          <vs-radio v-on:change="externalFilterChanged('satissonuc')" vs-name="radios1" vs-value="luis">Satışı ve
            İhtiyaç
            olanlar</vs-radio>
        </label>


        <label style="    margin-right: 10px;">
          <vs-radio v-on:change="externalFilterChanged('satisbakiyesonuc')" vs-name="radios1" vs-value="luis">Satış,
            İhtiyaç ve Stoğu olanlar</vs-radio>
        </label>
      </div>

      <b-row>
        <b-col lg="2" sm="5">
          <b-form-input v-model="stokKod1" id="smallInput" placeholder="Stok kodu 1" />
        </b-col>
        <b-col lg="2" sm="5">
          <b-form-input v-model="stokKod2" id="smallInput" placeholder="Stok Kodu 2" />
        </b-col>
        <b-col cols="2">
          <vs-button style="border-radius: 5px; width: 100%" type="gradient" id="button-with-loading-yeni2"
            class="vs-con-loading__container" size="small" @click="getFilter()">Filtrele</vs-button></b-col>
      </b-row>
      <ag-grid-vue style="width: 100%; height: 550px; margin-top: 25px" class="ag-theme-alpine"
        :defaultColDef="defaultColDef" :columnDefs="columnDefs" :rowData="rowData" :rowSelection="rowSelection"
        :localeText="localeText" :suppressAggFuncInHeader="true" :enableCellChangeFlash="true" :animateRows="true"
        :isExternalFilterPresent="isExternalFilterPresent" :doesExternalFilterPass="doesExternalFilterPass"
        :pagination="true" :isRowSelectable="isRowSelectable" :suppressCopyRowsToClipboard="true"
        :rowClassRules="rowClassRules" :pinnedBottomRowData="pinnedBottomRowData" @grid-ready="onGridReady"
        @rowClicked="onSelectionChanged" @cell-value-changed="onCellValueChanged" @filter-changed="onFilterChanged2"
        @first-data-rendered="onFirstDataRendered">
      </ag-grid-vue>
    </vs-card>
    <vs-prompt title="Onayla" acceptText="Kaydet" cancelText="Vazgeç" @accept="kaydet" :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <b-row style="align-items: center">
          <b-col lg="12">
            <span>İşlemi Onaylıyor musunuz?</span>
          </b-col>
          <b-col lg="12">
            <vs-textarea v-model="textDesc" />
          </b-col>
        </b-row>
      </div>
    </vs-prompt>
    <vs-popup type="filled" pazaryer title="TAHSİLAT MAKBUZU" :active.sync="popupKartDetay">
      <div>
        <b-row>
          <vs-card>
            <b-row style="margin-top: 25px; padding: 15px">
              <b-col lg="12">
                <b-row>
                  <b-col lg="4">
                    <v-select v-model="secilenReceipt" :options="RECEIPTLIST" label="ACTNAME" placeholder="Termin"
                      style="" @input="mailList()">
                      <template slot="option" slot-scope="option">
                        {{ option.ACTNAME }} ({{ option.ISLEM }})
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        {{ option.ACTNAME }} ({{ option.ISLEM }})
                      </template>
                    </v-select>
                  </b-col>
                  <b-col lg="6">
                    <vs-input style="
                       padding: 0.4rem !important;
                       margin-top: 0;
                       width: 400px;
                     " icon-after="true" icon="email" label-placeholder="E-Mail" v-model="girilenMail" /></b-col>

                  <b-col lg="2" align-self="center">
                    <vs-button @click="mailBtnGonder()" color="primary" icon="send" type="flat"
                      id="button-with-loading-yeni2" class="vs-con-loading__container"></vs-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row style="padding: 15px">
              <b-col lg="12">
                <vs-table :data="mailListesi" max-height="250px">
                  <template slot="thead">
                    <vs-th style="background-color: #e8e8fa" sort-key="EMAIL">E-Mail</vs-th>
                    <vs-th style="background-color: #e8e8fa" sort-key="YETKILI">Yetkili</vs-th>
                    <vs-th style="background-color: #e8e8fa" sort-key="MISSION">Görev</vs-th>
                    <vs-th style="background-color: #e8e8fa"></vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td style="font-size: small" :data="data[indextr].EMAIL">
                        {{ data[indextr].EMAIL }}
                      </vs-td>
                      <vs-td style="font-size: small" :data="data[indextr].YETKILI">
                        {{ data[indextr].YETKILI }}
                      </vs-td>
                      <vs-td style="font-size: small" :data="data[indextr].MISSION">
                        {{ data[indextr].MISSION }}
                      </vs-td>
                      <vs-td>
                        <vs-button @click="mailBtnGonder(data[indextr].EMAIL)" color="primary" icon="send"
                          type="flat"></vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </b-col>
            </b-row>
          </vs-card>
        </b-row>
      </div>
      <SatAlPlnInvoice ref="invoiceRef" />
    </vs-popup>
  </div>
</template>
<script>
import SatAlPlnInvoice from "../components/crm-components/satinalma-components/SatAlPlnInvoice.vue";
import { Icon } from "@iconify/vue2";
import Store from "../../store/store";
import state from "../../store/state";
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import PlanlamaButon from "../components/crm-components/satinalma-components/PlanlamaButon.vue";
import CariAutosuggest from "../components/crm-components/satinalma-components/CariAutosuggest.vue";
import SatinalmaPlanlamaFiyatModal from "../components/crm-components/satinalma-components/SatinalmaPlanlamaFiyatModal.vue";
import ButtonPrimary from "../components/crm-components/global-components/ButtonPrimary.vue";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";
import SatPlanlamaIhrCellGorunum from "./CellRenderers/SatPlanlamaIhrCellGorunum.vue";
import SatPlanlamaSonucCellGorunum from "./CellRenderers/SatPlanlamaSonucCellGorunum.vue";
import SatPlanlamaMiktarCellRenderer from "./CellRenderers/SatPlanlamaMiktarCellRenderer.vue";

export default {
  data() {
    return {
      totalMiktar: 0.0,
      totalKilo: 0.0,
      totalSonuc: 0.0,
      pinnedBottomRowData: null,
      rowClassRules: null,
      textDesc: "",
      toplamListe: [],
      secilenReceipt: "",
      mailListesi: [],
      girilenMail: "",
      popupKartDetay: false,
      uniqueTranscode: [],
      secimText: "",
      activePrompt: false,
      selectedRows: [],
      isRowSelectable: null,
      ihtiyacOlanlarValidate: false,
      ageType: "everyone",
      checkBox1: false,
      checkBox2: false,
      checkBox3: false,
      stokKod1: "",
      stokKod2: "",
      listsize: "",
      listtitle: "Listele",
      query: "",
      filteredOptions: [],
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      rowSelection: null,

      localeText: null,
      columnDefs: null,
      rowData: null,
      secilenTermin: "",
      secilenSatis: "",
      satisList: [
        { name: "1 Aylık Satış", val: "-1" },
        { name: "2 Aylık Satış", val: "-2" },
        { name: "3 Aylık Satış", val: "-3" },
        { name: "4 Aylık Satış", val: "-4" },
        { name: "5 Aylık Satış", val: "-5" },
        { name: "6 Aylık Satış", val: "-6" },
        { name: "7 Aylık Satış", val: "-7" },
        { name: "8 Aylık Satış", val: "-8" },
        { name: "9 Aylık Satış", val: "-9" },
        { name: "10 Aylık Satış", val: "-10" },
        { name: "11 Aylık Satış", val: "-11" },
        { name: "12 Aylık Satış", val: "-12" }
      ],
      terminList: [
        { name: "1 Ay", val: "1" },
        { name: "2 Ay", val: "2" },
        { name: "3 Ay", val: "3" },
        { name: "4 Ay", val: "4" },
        { name: "5 Ay", val: "5" },
        { name: "6 Ay", val: "6" },
        { name: "7 Ay", val: "7" },
        { name: "8 Ay", val: "8" },
        { name: "9 Ay", val: "9" },
        { name: "10 Ay", val: "10" },
        { name: "11 Ay", val: "11" },
        { name: "12 Ay", val: "12" }
      ],
      fiyatlar: [],
      secilenGroupCode: "",
      allAct: "",
      ACTID: "",
      ACTGROUP: "",
      RECEIPTLIST: []
    };
  },
  components: {
    SatAlPlnInvoice,
    Icon,
    SatPlanlamaMiktarCellRenderer,
    SatPlanlamaSonucCellGorunum,
    SatPlanlamaIhrCellGorunum,
    TextGorunumCellRenderer,
    ButtonPrimary,
    SatinalmaPlanlamaFiyatModal,
    PlanlamaButon,
    AgGridVue,
    "v-select": vSelect,
    CariAutosuggest
    //PazaryeriTopluGuncelleme,
  },

  methods: {
    onFilterChanged2(e) {
      let list = [];
      this.gridApi.forEachNodeAfterFilter((node) => {
        list.push(node.data);
      });

      this.totalKilo = 0;
      this.totalSonuc = 0.0;
      this.totalMiktar = 0.0
      list.forEach((val, index) => {
        this.totalKilo += val.KILO;
        this.totalSonuc += val.SONUC;
        this.totalMiktar += val.miktar

      });

      this.pinnedBottomRowData = this.createData(1, "Bottom");
    },
    refreshData() {
      this.selectedRows.forEach((val) => {
        const indexForRow = this.rowData.findIndex(object => {
          return object.STOCKID === val.STOCKID;
        });
        const rowNode = this.gridApi.getDisplayedRowAtIndex(indexForRow);
        rowNode.setDataValue("isCreate", "success");
      });
      this.selectedRows = []
      this.gridApi.deselectAll();
    },
    mailList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ACTID: vm.secilenReceipt.ACTID
      };

      soap.createClient(url, function (err, client) {
        client.INT_Ls_Act_ContactList(args, function (err, result) {
          if (result.INT_Ls_Act_ContactListResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.INT_Ls_Act_ContactListResult);
          vm.mailListesi = vm.veriler;
        });
      });
    },
    mailBtnGonder(mail) {
      const vs = this.$vs;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {};
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni2",
        scale: 0.45
      });

      if (vm.girilenMail != "") {
        args = {
          ALICI: vm.girilenMail,
          MESAJ:
            vm.secilenReceipt.ACTNAME +
            "</br>" +
            " Caner Otomotiv Ltd. Şti. tarafından hazırlanan ve Onayınızı Bekleyen Satış Teklifi bulunmaktadır." +
            "</br>" +
            " Onaylama için   http://int.kamyonyedekparca.com/teklif-siparis-onay/" +
            vm.secilenReceipt.RECEIPTID +
            "/" +
            vm.secilenReceipt.ACTID +
            "/" +
            vm.secilenReceipt.TRANSTYPE +
            "/" +
            vm.secilenReceipt.TRANSCODE +
            "/" +
            vm.girilenMail +
            "/" +
            vm.secilenReceipt.ISLEM +
            "</br> </br> </br> Saygılarımla",
          KONU: "Sipariş talep onay"
        };
      } else if (vm.girilenMail == "") {
        vm.$store.commit("account/CARI_TAHSILAT_GECVADE_VALIDATE", false);
        if (mail != "" && typeof mail != "undefined") {
          args = {
            ALICI: mail,
            MESAJ:
              vm.secilenReceipt.ACTNAME +
              "</br>" +
              " Caner Otomotiv Ltd. Şti. tarafından hazırlanan ve Onayınızı Bekleyen Satış Teklifi bulunmaktadır." +
              "</br>" +
              " Onaylama için   http://int.kamyonyedekparca.com/teklif-siparis-onay/" +
              vm.secilenReceipt.RECEIPTID +
              "/" +
              vm.secilenReceipt.ACTID +
              "/" +
              vm.secilenReceipt.TRANSTYPE +
              "/" +
              vm.secilenReceipt.TRANSCODE +
              "/" +
              vm.girilenMail +
              "/" +
              vm.secilenReceipt.ISLEM +
              "</br> </br> </br> Saygılarımla",
            KONU: "Sipariş talep onay"
          };
        } else {
          vs.loading.close("#button-with-loading-yeni2 > .con-vs-loading");
          vs.notify({
            title: "Hata",
            text: "Mail adresi giriniz.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center"
          });
        }
      }
      soap.createClient(url, function (err, client) {
        client.mailGonder(args, function (err, result) {
          if (result.mailGonderResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let veriler = JSON.parse(result.mailGonderResult);
            if (veriler.response == "Ok") {
              vm.$store.commit("account/CARI_TAHSILAT_GECVADE_VALIDATE", true);

              vs.loading.close("#button-with-loading-yeni2 > .con-vs-loading");
              setTimeout(() => {
                vm.adminMailGonder();
              }, 15000);
            }
          } catch (error) {
            vs.loading.close("#button-with-loading-yeni2 > .con-vs-loading");
            vs.notify({
              title: "Mail",
              text: "Mail göndermede hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });

      vm.girilenMail = "";
    },
    mailGonder() {
      this.popupKartDetay = true;
    },
    yazdir() {
      this.$refs.invoiceRef.yazdir(
        this.selectedRows
        // this.tahsilatTarihi
      );
    },
    onayla() {
      var vs = this.$vs;
      this.selectedRows = this.gridApi.getSelectedRows();
      if (this.selectedRows.length == 0) {
        vs.notify({
          title: this.secimText,
          text: "Seçim yapmadınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        let kontrol = false;
        this.uniqueTranscode = [];
        let today = new Date();
        var formatreqdate = moment(String(today)).format("HHmmss");
        const actDeger = [...new Set(this.selectedRows.map(x => x.ACTID))];
        actDeger.forEach((val, index) => {
          this.uniqueTranscode.push({ val: val, name: formatreqdate + val });
        });

        this.selectedRows.forEach((val, index) => {
          if (parseFloat(val.fiyat) == 0.0) {
            kontrol = true;
          }
        });
        if (kontrol == false) {
          this.activePrompt = true;
        } else {
          vs.notify({
            title: "Teklif",
            text: "Fiyat ya da cari bilgisinin eksik olmadığından emin olun",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center"
          });
        }
      }
    },
    kaydet() {
      this.yazdir();
      let deger = _.groupBy(this.selectedRows, "ACTID");
      this.toplamListe = [];

      const gruplanmisYillarListesi = Object.keys(deger);
      gruplanmisYillarListesi.forEach((key, i) => {
        var pazaryeriyillar = deger[key];
        let toplam = 0.0;
        let toplamVat = 0.0;
        let toplamDs1 = 0.0;
        let toplamDs2 = 0.0;
        let toplamDs3 = 0.0;

        pazaryeriyillar.forEach((val, index) => {
          toplam += parseFloat(val.miktar) * parseFloat(val.fiyat);
          toplamDs1 += parseFloat(val.IND1);
          toplamDs2 += parseFloat(val.IND2);
          toplamDs3 += parseFloat(val.IND3);
          toplamVat += toplam * (1 + parseFloat(val.VATSALES) / 100);
        });

        this.toplamListe.push({
          name: pazaryeriyillar[0].ACTID,
          valTutar: toplam,
          valDs1: toplamDs1,
          valDs2: toplamDs2,
          valDs3: toplamDs3,
          valVat: toplamVat - toplam,
          valVatToplam: toplamVat
        });
      });

      if (this.secimText == "Siparis") this.siparisEkle(0);
      if (this.secimText == "Teklif") this.teklifEkle(0);
    },
    siparisEkle(index) {
      var vs = this.$vs;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      if (vm.selectedRows.length == index) {

        vm.textDesc = ""
        //  vm.selectedRows = [];
        //  vm.gridApi.deselectAll();
        vs.notify({
          title: "Sipariş",
          text: "Sipariş Ekleme Başarılı",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center"
        });
      } else {
        let today = new Date();
        var formatreqdate = moment(String(today)).format("DDMMYYYY");
        let uniqTrans = vm.uniqueTranscode.filter(post => {
          return post.val == vm.selectedRows[index].ACTID;
        });

        const args = {
          token: Store.state.tokenId,
          TRANSTYPE: "203",
          TRANSCODE: formatreqdate + "-" + uniqTrans[0].name, //ddMMYYYY
          ACTID: vm.selectedRows[index].ACTID,
          EMPLOYEEID: Store.state.employeeid,
          TARIH: vm.selectedRows[index].TRANSDATE,
          STOCKID: vm.selectedRows[index].STOCKID,
          ITEMNO: index + 1,
          TARIH: moment(String(today)).format("DD-MM-YYYY"),
          QUANTITY: vm.selectedRows[index].miktar,
          QUANTITY2: vm.selectedRows[index].KILO,
          PRICE: vm.selectedRows[index].fiyat,
          DISCOUNT1: vm.selectedRows[index].IND1,
          DISCOUNT2: vm.selectedRows[index].IND2,
          DISCOUNT3: vm.selectedRows[index].IND3,
          DISCOUNTSUM: parseFloat(vm.selectedRows[index].IND1) +
            parseFloat(vm.selectedRows[index].IND2) + parseFloat(vm.selectedRows[index].IND3),
          DESCRIPTION: vm.textDesc,
          VATSUM:
            vm.selectedRows[index].fiyat *
            vm.selectedRows[index].miktar *
            (1 + parseFloat(vm.selectedRows[index].VATSALES) / 100) -
            vm.selectedRows[index].fiyat * vm.selectedRows[index].miktar,
          TOTAL:
            vm.selectedRows[index].fiyat * vm.selectedRows[index].miktar
        };

        const indexForRow = vm.rowData.findIndex(object => {
          return object.STOCKID === vm.selectedRows[index].STOCKID;
        });


        soap.createClient(url, function (err, client) {
          client.INT_Ins_Orders(args, function (err, result) {
            if (result.INT_Ins_OrdersResult == "-1") {
              Store.dispatch("logout");
              //vm.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_Ins_OrdersResult);

              if (vm.veriler.jsonData != "[]") {
                let list = JSON.parse(vm.veriler.jsonData);

                vm.RECEIPTLIST.push({
                  RECEIPTID: list[0].RECEIPTID,
                  RECEIPTNO: list[0].RECEIPTNO,
                  TRANSCODE: formatreqdate + "-" + uniqTrans.name, //ddMMYYYY
                  TRANSTYPE: list[0].TRANSTYPE,
                  ACTID: vm.selectedRows[index].ACTID,
                  ACTNAME: vm.selectedRows[index].cariAdi,
                  ISLEM: "Siparis"
                });
              }
              const rowNode = vm.gridApi.getDisplayedRowAtIndex(indexForRow);
              rowNode.setDataValue("isCreate", true);
              vm.siparisEkle(index + 1);
            } catch (error) {
              vs.notify({
                title: "Sipariş",
                text: "Sipariş Eklenirken Hata Oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      }
    },
    teklifEkle(index) {
      var vs = this.$vs;
      var vm = this;
      const soap = require("soap");

      const url = state.sistemAddress;

      if (vm.selectedRows.length == index) {
        vm.textDesc = ""
        //  vm.selectedRows = [];
        //  vm.gridApi.deselectAll();
        vs.notify({
          title: "Teklif",
          text: "Teklif Ekleme Başarılı",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center"
        });
      } else {
        let today = new Date();
        var formatreqdate = moment(String(today)).format("DDMMYYYY");
        let uniqTrans = vm.uniqueTranscode.filter(post => {
          return post.val == vm.selectedRows[index].ACTID;
        });

        const args = {
          token: Store.state.tokenId,

          TRANSTYPE: "213",
          TRANSCODE: formatreqdate + "-" + uniqTrans[0].name, //ddMMYYYY
          ACTID: vm.selectedRows[index].ACTID,
          EMPLOYEEID: Store.state.employeeid,
          TARIH: moment(String(today)).format("DD-MM-YYYY"),
          STOCKID: vm.selectedRows[index].STOCKID,
          ITEMNO: index + 1,
          QUANTITY: vm.selectedRows[index].miktar,
          QUANTITY2: vm.selectedRows[index].KILO,
          PRICE: vm.selectedRows[index].fiyat,
          DISCOUNT1: vm.selectedRows[index].IND1,
          DISCOUNT2: vm.selectedRows[index].IND2,
          DISCOUNT3: vm.selectedRows[index].IND3,
          DISCOUNTSUM: parseFloat(vm.selectedRows[index].IND1) +
            parseFloat(vm.selectedRows[index].IND2) + parseFloat(vm.selectedRows[index].IND3),
          DESCRIPTION: vm.textDesc,
          VATSUM:
            vm.selectedRows[index].fiyat *
            vm.selectedRows[index].miktar *
            (1 + parseFloat(vm.selectedRows[index].VATSALES) / 100) -
            vm.selectedRows[index].fiyat * vm.selectedRows[index].miktar,
          TOTAL:
            vm.selectedRows[index].fiyat * vm.selectedRows[index].miktar
        };
        const indexForRow = vm.rowData.findIndex(object => {
          return object.STOCKID === vm.selectedRows[index].STOCKID;
        });
        soap.createClient(url, function (err, client) {
          client.INT_Ins_Teklif(args, function (err, result) {
            if (result.INT_Ins_TeklifResult == "-1") {
              Store.dispatch("logout");
              //vm.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_Ins_TeklifResult);
              if (vm.veriler.jsonData != "[]") {
                let list = JSON.parse(vm.veriler.jsonData);

                vm.RECEIPTLIST.push({
                  RECEIPTID: list[0].RECEIPTID,
                  RECEIPTNO: list[0].RECEIPTNO,
                  TRANSCODE: formatreqdate + "-" + uniqTrans.name, //ddMMYYYY
                  TRANSTYPE: list[0].TRANSTYPE,
                  ACTID: vm.selectedRows[index].ACTID,
                  ACTNAME: vm.selectedRows[index].cariAdi,
                  ISLEM: "Teklif"
                });
              }
              const rowNode = vm.gridApi.getDisplayedRowAtIndex(indexForRow);
              rowNode.setDataValue("isCreate", true);
              vm.teklifEkle(index + 1);
            } catch (error) {
              vs.notify({
                title: "Teklif",
                text: "Teklif Eklenirken Hata Oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      }
    },
    satinalmaPlanlamaListForACT(index, item, stokid, group) {
      const rowNode = this.gridApi.getDisplayedRowAtIndex(index);
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ACTID: item.ACTID,
        STOCKGROUP: group,
        STOCKID: stokid
      };
      soap.createClient(url, function (err, client) {
        client.INT_Ls_SalPlnForACT(args, function (err, result) {
          if (result.INT_Ls_SalPlnForACTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Ls_SalPlnForACTResult);
            let list = JSON.parse(vm.veriler.jsonData);
            /*
                        let secilenFiyat =
                          list[0].stPrice1 !== null && list[0].stPrice1 != 0
                            ? list[0].stPrice1
                            : list[0].stPrice2 !== null && list[0].stPrice2 != 0
                            ? list[0].stPrice2
                            : list[0].stPrice !== null && list[0].stPrice != 0
                            ? list[0].stPrice
                            : 0;
                        let dis1 = 0.0,
                          dis2 = 0.0,
                          dis3 = 0.0;
                        if (list[0].stPrice1 !== null && list[0].stPrice1 != 0) {
                          secilenFiyat = list[0].stPrice1;
                          dis1 = list[0].DISCOUNT1;
                          dis2 = list[0].DISCOUNT2;
                          dis3 = list[0].DISCOUNT3;
                        } else if (list[0].stPrice2 !== null && list[0].stPrice2 != 0) {
                          secilenFiyat = list[0].stPrice2;
                          dis1 = list[0].stDISCOUNT1;
                          dis2 = list[0].stDISCOUNT2;
                          dis3 = list[0].stDISCOUNT3;
                        } else if (list[0].stPrice !== null && list[0].stPrice != 0) {
                          secilenFiyat = list[0].stPrice;
                        } else {
                          secilenFiyat = 0;
                          dis1 = 0.0;
                          dis2 = 0.0;
                          dis3 = 0.0;
                        }*/

            rowNode.setDataValue("fiyat", list[0].price);

            rowNode.setDataValue("IND1", list[0].dis1);
            rowNode.setDataValue("IND2", list[0].dis2);
            rowNode.setDataValue("IND3", list[0].dis3);
            rowNode.setDataValue("ACTID", item.ACTID);

            rowNode.setDataValue("sonNetFiyat", (isNaN(parseInt(list[0].price)) == false
              ? parseFloat(list[0].price).toFixed(2)
              : 0.0) - (isNaN(parseInt(list[0].dis1)) == false
                ? parseFloat(list[0].dis1).toFixed(2)
                : 0.0) - (isNaN(parseInt(list[0].dis2)) == false
                  ? parseFloat(list[0].dis2).toFixed(2)
                  : 0.0) - (isNaN(parseInt(list[0].dis3)) == false
                    ? parseFloat(list[0].dis3).toFixed(2)
                    : 0.0));


            //  vm.allAct = JSON.parse(vm.veriler.jsonData);
          } catch (error) { }
        });
      });
    },
    getFilter() {
      this.rowDataAccount = this.rowData2.filter(post => {
        return this.stokKod1.toUpperCase() <= post.STOCKNO.toString();
      });
      this.rowDataAccount2 = this.rowDataAccount.filter(post => {
        // console.log('t0141' > post.STOCKNO > 't0146')
        return this.stokKod2.toUpperCase() >= post.STOCKNO.toString();
      });
      this.rowData = this.rowDataAccount2;
      if (this.stokKod2 == "" && this.stokKod1 == "")
        this.rowData = this.rowData2;
    },
    externalFilterChanged(newValue) {
      this.ageType = newValue;
      this.gridApi.onFilterChanged();
    },
    isExternalFilterPresent() {
      // if ageType is not everyone, then we are filtering
      return this.ageType !== "everyone";
    },
    doesExternalFilterPass(node) {
      if (node.data) {
        switch (this.ageType) {
          case "sonuc":
            return node.data.SONUC > 0;

          case "satis":
            return node.data.SATIS > 0;

          case "bakiye":
            return node.data.QDEPOT > 0;

          case "satisbakiye":
            return node.data.QDEPOT > 0 && node.data.SATIS > 0;

          case "satissonuc":
            return node.data.SONUC > 0 && node.data.SATIS > 0;
          case "bakiyesonuc":
            return node.data.QDEPOT > 0 && node.data.SONUC > 0;
          case "satisbakiyesonuc":
            return (
              node.data.QDEPOT > 0 && node.data.SONUC > 0 && node.data.SATIS > 0
            );

          default:
            return true;
        }
      }
      return true;
    },
    setSonucData(val, sonuc) {
      const rowNode = this.gridApi.getDisplayedRowAtIndex(val);
      rowNode.setDataValue("SONUC", sonuc);
    },
    getSuggestionValue(suggestion) {
      this.ACTNAME = suggestion.item.ACTNAME;
      this.ACTID = suggestion.item.ACTID;
      this.ACTGROUP = suggestion.item.GROUPCODE;
      this.$store.commit("account/SATINALMA_ACTID", this.ACTID);
      this.getPlanlamaList2();
      return suggestion.item.ACTNAME;
    },
    allActInformation() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId
      };

      soap.createClient(url, function (err, client) {
        client.LS_ALL_ACT(args, function (err, result) {
          if (result.LS_ALL_ACTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.LS_ALL_ACTResult);
          vm.allAct = JSON.parse(vm.veriler.jsonData);
        });
      });
    },
    onInputChange(text) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ARANAN: text
      };

      soap.createClient(url, function (err, client) {
        client.INT_Ls_Act_ActSec(args, function (err, result) {
          if (result.INT_Ls_Act_ActSecResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.INT_Ls_Act_ActSecResult);
          vm.datasuggest = vm.veriler;

          if (text === "" || text === undefined) {
            vm.isDisabled = true;
            return;
          }
          vm.filteredOptions = [
            {
              data: vm.datasuggest.filter(option => {
                return (
                  option.ACTNAME.toLowerCase().indexOf(vm.query.toLowerCase()) >
                  -1
                );
              })
            }
          ];
        });
      });
    },
    onCellValueChanged(params) {
      try {
        const rowNode = this.gridApi.getDisplayedRowAtIndex(params.rowIndex);
        const colId = params.column.getId();

        if (colId === "fiyat") {
          params.data.fiyat = params.newValue;
          /*  rowNode.setDataValue("IND1", Store.state.account.planlamaIND1);
          rowNode.setDataValue("IND2", Store.state.account.planlamaIND2);
          rowNode.setDataValue("IND3", Store.state.account.planlamaIND3);
             if (typeof params.newValue.PRICE == "undefined") {
       
            if(typeof params.oldValue == "undefined")
              params.oldValue=0
            params.data.fiyat = params.oldValue;
          } else {
       
            rowNode.setDataValue("fiyat", params.newValue.PRICE);
            rowNode.setDataValue("IND1", params.newValue.IND1);
            rowNode.setDataValue("IND2", params.newValue.IND2);
            rowNode.setDataValue("IND3", params.newValue.IND3);

            params.data.fiyat = params.newValue.PRICE;
          }
          if (params.newValue == "") {
        
          //  rowNode.setDataValue("fiyat", params.oldValue);
          }*/
        } else if (colId === "IND1") {
          params.data.IND1 = params.newValue;
        } else if (colId === "IND2") {
          params.data.IND2 = params.newValue;
        } else if (colId === "IND3") {
          params.data.IND3 = params.newValue;
        } else if (colId === "miktar") {
          let mikKontrol = [];
          if (typeof params.data.paketDeger != undefined) {
            params.data.paketDeger.forEach((val, index) => {
              if ((params.data.miktar / val).toString().includes(".") || (params.data.miktar / val).toString().includes(",")) { mikKontrol.push("false"); }
              else { mikKontrol.push("true"); }
            });
          }
          if (mikKontrol.toString().includes("true"))
            params.data.miktar = params.newValue
          else {
            const vs = this.$vs;
            vs.notify({
              title: "Planlama",
              text: "Girilen adet paket adetleri ile uyuşmuyor",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
              fized: true
            });
          }
          rowNode.setDataValue("sonNetFiyat", params.data.miktar * params.data.sonNetFiyat);
          rowNode.setDataValue("KILO", params.data.miktar * params.data.KILO);

        } else if (colId === "cariAdi") {
          params.data.cariAdi = params.newValue;
          params.data.ACTID = Store.state.account.planlamaCariId;
          //   rowNode.setDataValue("cariAdi", params.newValue.ACTNAME);

          /*   if (typeof params.newValue.ACTNAME != "undefined") {
            rowNode.setDataValue("ACTNAME", params.newValue.ACTNAME);
            params.data.ACTNAME = params.newValue.ACTNAME;
            params.data.ACTID = params.newValue.ACTID;
          }*/
        } /* else if (colId === "miktar") {
            this.isRowSelectable = params => {
            if (parseInt(node.data.miktar) > 0)
              //node.setSelected(true);
              return !!params.data.miktar;
          };
        }*/
        if (colId === "isCreate") { }
        else {
          this.totalPrice = 0.0
          this.totalMiktar = 0.0
          params.api.forEachNode(node => {
            this.totalPrice += parseFloat(node.data.fiyat)
            if (parseInt(node.data.miktar) > 0) { this.totalMiktar += parseFloat(node.data.miktar); }
            if (parseInt(node.data.miktar) > 0 && (node.data.isCreate == true || node.data.isCreate == false)) { node.setSelected(true); }
            else node.setSelected(false);
          });

          this.pinnedBottomRowData = this.createData(1, "Bottom")
        }

      } catch (error) {
        console.log(error);
      }
    },

    sortByFiyatDesc() {
      this.gridColumnApi.applyColumnState({
        state: [{ colId: "fiyat", sort: "desc" }],
        defaultState: { sort: null }
      });
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onSelectionChanged(params) {
      this.totalMiktar = 0.0;
      params.api.forEachNode(node => {
        if (parseInt(node.data.miktar) > 0 && (node.data.isCreate == true || node.data.isCreate == false)) { node.setSelected(true); }
        else node.setSelected(false);
      });
      this.secilenGroupCode = params.data.GROUPCODE;
      //   this.$store.commit("account/SATINALMA_ACTID", "");
      this.selectedRows = this.gridApi.getSelectedRows();
      // this.$store.commit("account/SATINALMA_TUR", this.tur);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    StringToXML(oString) {
      //code for IE
      if (window.ActiveXObject) {
        var oXML = new ActiveXObject("Microsoft.XMLDOM");
        oXML.loadXML(oString);
        return oXML;
      }
      // code for Chrome, Safari, Firefox, Opera, etc.
      else {
        return new DOMParser().parseFromString(oString, "text/xml");
      }
    },
    xml2json(xml) {
      try {
        var obj = {};

        if (xml.children.length > 0) {
          for (var i = 0; i < xml.children.length; i++) {
            var item = xml.children.item(i);
            var nodeName = item.nodeName;

            if (typeof obj[nodeName] == "undefined") {
              obj[nodeName] = this.xml2json(item);
            } else {
              if (typeof obj[nodeName].push == "undefined") {
                var old = obj[nodeName];

                obj[nodeName] = [];
                obj[nodeName].push(old);
              }
              obj[nodeName].push(this.xml2json(item));
            }
          }
        } else {
          obj = xml.textContent;
        }
        return obj;
      } catch (e) {
        console.log(e.message);
      }
    },

    getPlanlamaList2() {
      var vm = this;
      var vs = this.$vs;
      vm.totalKilo = 0.0;
      vm.totalSonuc = 0.0;
      vm.totalMiktar = 0.0
      vm.totalPrice = 0.0

      const soap = require("soap");
      const url = state.sistemAddress;
      if (
        typeof vm.secilenSatis.val == "undefined" &&
        typeof vm.secilenTermin.val == "undefined"
      ) {
        const vs = this.$vs;
        vs.notify({
          title: "Satınalma ",
          text: "Satış ve Termin Değeri Seçiniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
          fized: true
        });
      } else {
        vs.loading({
          background: "#0064fa",
          color: this.colorLoading,
          container: "#button-with-loading-yeni",
          scale: 0.45
        });

        const args = {
          token: Store.state.tokenId,
          SATIS: vm.secilenSatis.val,
          AY: vm.secilenTermin.val,
          ILKKAYIT: "0",
          SONKAYIT: "50",
          stokkod1: "",
          stokkod2: "",
          satista: 0,
          bakiye: 0,
          ACTID: vm.ACTID,
          STOCKGROUP: vm.ACTGROUP
        };
        soap.createClient(url, function (err, client) {
          client.INT_Ls_SalPln(args, function (err, result) {
            if (result.INT_Ls_SalPlnResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_Ls_SalPlnResult);
              if (vm.veriler.response == "Ok") {
                vm.rowData = JSON.parse(vm.veriler.jsonData);
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");

                vm.rowData.forEach((val, index) => {
                  let deger = [];
                  let ACTIDD = "",
                    ACTNAMEE = "",
                    IND1 = "",
                    IND2 = "",
                    IND3 = "",
                    price = 0.0,
                    stPrice1 = 0.0,
                    stPrice2 = 0.0,
                    DISCOUNT1 = 0.0,
                    DISCOUNT2 = 0.0,
                    DISCOUNT3 = 0.0,
                    stDISCOUNT2 = 0.0,
                    stDISCOUNT1 = 0.0,
                    stDISCOUNT3 = 0.0,
                    fiyat = "";
                  var parseString = vm.StringToXML(val.detay);
                  deger = vm.xml2json(parseString);
                  if (typeof deger.row != "undefined") {
                    IND1 = deger.row.IND1;
                    IND2 = deger.row.IND2;
                    IND3 = deger.row.IND3;
                    fiyat = deger.row.fiyat;

                  } else {
                    ACTIDD = 0.0;
                    IND1 = 0.0;
                    IND2 = 0.0;
                    IND3 = 0.0;
                    fiyat = 0.0;

                    ACTNAMEE = "";
                  }
                  let Sonuc1 = 0.0,
                    Sonuc2 = 0.0,
                    DepoAdt = 0;

                  Sonuc1 =
                    parseInt(val.KRITIKSTOK) +
                    parseInt(val.SATIS) +
                    parseInt(val.SATSIP);

                  Sonuc2 =
                    parseInt(val.IADE) +
                    parseInt(val.SATALSIP) +
                    parseInt(val.QDEPOT);

                  let sonuc = Sonuc1 - Sonuc2;
                  vm.totalKilo += val.KILO;
                  vm.totalSonuc += parseInt(sonuc);



                  vm.rowData[index] = {
                    isCreate: false,
                    KILO: val.KILO,
                    GROUPCODE: val.GROUPCODE,
                    SONUC: parseInt(sonuc),
                    CARIADT: val.CARIADT,
                    COMPANYID: val.COMPANYID,
                    IADE: val.IADE,
                    IHR: val.IHR,
                    KRITIKSTOK: parseInt(val.KRITIKSTOK),
                    QDEPOT: val.QDEPOT,
                    SATALSIP: val.SATALSIP,
                    SATIADE: val.SATIADE,
                    SATIS: val.SATIS,
                    SATSIP: val.SATSIP,
                    STOCKID: val.STOCKID,
                    STOCKNAME: val.STOCKNAME,
                    STOCKNO: val.STOCKNO,
                    cariAdi: vm.ACTNAME,
                    ACTID: vm.ACTID,
                    VATSALES: val.VATSALES,
                    sonFiyat:
                      isNaN(parseInt(fiyat)) == false
                        ? parseFloat(fiyat).toFixed(2)
                        : 0.0,
                    sonNetFiyat:
                      isNaN(parseInt(fiyat)) == false
                        ? parseFloat(fiyat).toFixed(2)
                        : 0.0,
                    fiyat:
                      typeof val.stPrice1 != "undefined" &&
                        val.stPrice1 !== null
                        ? val.stPrice1
                        : typeof val.stPrice2 != "undefined" &&
                          val.stPrice2 !== null
                          ? val.stPrice2
                          : typeof val.stPrice != "undefined" &&
                            val.stPrice !== null
                            ? val.stPrice
                            : 0,
                    IND1:
                      typeof val.stPrice1 != "undefined" &&
                        val.stPrice1 !== null
                        ? val.DISCOUNT1
                        : typeof val.stPrice2 != "undefined" &&
                          val.stPrice2 !== null
                          ? val.stDISCOUNT1
                          : 0,
                    IND2:
                      typeof val.stPrice1 != "undefined" &&
                        val.stPrice1 !== null
                        ? val.DISCOUNT2
                        : typeof val.stPrice2 != "undefined" &&
                          val.stPrice2 !== null
                          ? val.stDISCOUNT2
                          : 0,
                    IND3:
                      typeof val.stPrice1 != "undefined" &&
                        val.stPrice1 !== null
                        ? val.DISCOUNT3
                        : typeof val.stPrice2 != "undefined" &&
                          val.stPrice2 !== null
                          ? val.stDISCOUNT3
                          : 0,
                    cariId: vm.ACTID
                  };
                  vm.totalPrice += parseFloat(vm.rowData[index].fiyat);
                });
                vm.rowData2 = vm.rowData;
                vm.ihtiyacOlanlarValidate = true;
                vm.query = "";
                vm.pinnedBottomRowData = vm.createData(1, "Bottom");
              } else {
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
                vs.notify({
                  title: "Hata",
                  text: "Liste getirilirken hata oluştu" + vm.veriler.error,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center"
                });
              }
              vm.ACTNAME = "";
              vm.ACTID = "";
              vm.ACTGROUP = "";
            } catch (error) {
              console.log(error);
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              vs.notify({
                title: "Hata",
                text: "Liste getirilirken hata oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      }
    },
    getPlanlamaList() {
      var vm = this;
      var vs = this.$vs;
      vm.totalKilo = 0.0;
      vm.totalSonuc = 0;
      vm.totalMiktar = 0.0
      vm.totalPrice = 0.0
      const soap = require("soap");
      const url = state.sistemAddress;
      if (
        typeof vm.secilenSatis.val == "undefined" &&
        typeof vm.secilenTermin.val == "undefined"
      ) {
        const vs = this.$vs;
        vs.notify({
          title: "Satınalma ",
          text: "Satış ve Termin Değeri Seçiniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
          fized: true
        });
      } else {
        vs.loading({
          background: "#0064fa",
          color: this.colorLoading,
          container: "#button-with-loading-yeni",
          scale: 0.45
        });

        const args = {
          token: Store.state.tokenId,
          SATIS: vm.secilenSatis.val,
          AY: vm.secilenTermin.val,
          ILKKAYIT: "0",
          SONKAYIT: "50",
          stokkod1: "",
          stokkod2: "",
          satista: 0,
          bakiye: 0,
          ACTID: vm.ACTID,
          STOCKGROUP: vm.ACTGROUP
        };
        soap.createClient(url, function (err, client) {
          client.INT_Ls_SalPln(args, function (err, result) {
            if (result.INT_Ls_SalPlnResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_Ls_SalPlnResult);
              if (vm.veriler.response == "Ok") {
                vm.rowData = JSON.parse(vm.veriler.jsonData);
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");

                vm.rowData.forEach((val, index) => {
                  let deger = [];
                  let paketDeger = [];
                  let ACTIDD = "",
                    ACTNAMEE = "",
                    IND1 = "",
                    IND2 = "",
                    IND3 = "",
                    price = 0.0,
                    stPrice1 = 0.0,
                    stPrice2 = 0.0,
                    DISCOUNT1 = 0.0,
                    DISCOUNT2 = 0.0,
                    DISCOUNT3 = 0.0,
                    stDISCOUNT2 = 0.0,
                    stDISCOUNT1 = 0.0,
                    stDISCOUNT3 = 0.0,
                    fiyat = "";
                  var parseString = vm.StringToXML(val.detay);
                  deger = vm.xml2json(parseString);

                  if (typeof deger.row != "undefined") {
                    ACTIDD = deger.row.ACTID;
                    IND1 = deger.row.IND1;
                    IND2 = deger.row.IND2;
                    IND3 = deger.row.IND3;
                    fiyat = deger.row.fiyat;
                    price = deger.row.price;

                    DISCOUNT1 = deger.row.dis1;
                    DISCOUNT2 = deger.row.dis2;
                    DISCOUNT3 = deger.row.dis3;

                    let cityArr = vm.allAct.filter(post => {
                      return post.ACTID.toString().includes(ACTIDD.toString());
                    });
                    ACTNAMEE = cityArr[0].ACTNAME;
                  } else {
                    ACTIDD = 0.0;
                    IND1 = 0.0;
                    IND2 = 0.0;
                    IND3 = 0.0;
                    fiyat = 0.0;
                    price = 0.0;
                    DISCOUNT1 = 0.0;
                    DISCOUNT2 = 0.0;
                    DISCOUNT3 = 0.0;

                    ACTNAMEE = "";
                  }
                  if (typeof val.paketAdetleri != "undefined" && val.paketAdetleri != null && val.paketAdetleri != "")
                    paketDeger = val.paketAdetleri.split('-')

                  let Sonuc1 = 0.0,
                    Sonuc2 = 0.0,
                    DepoAdt = 0;
                  /*
                  if (parseInt(val.KRITIKSTOK) > parseInt(val.QDEPOT)) {
                    DepoAdt = parseInt(val.KRITIKSTOK) - parseInt(val.QDEPOT);
                  } else {
                    DepoAdt = 0;
                  }*/

                  Sonuc1 =
                    parseInt(val.KRITIKSTOK) +
                    parseInt(val.SATIS) +
                    parseInt(val.SATSIP);

                  Sonuc2 =
                    parseInt(val.IADE) +
                    parseInt(val.SATALSIP) +
                    parseInt(val.QDEPOT);

                  let sonuc = Sonuc1 - Sonuc2;
                  vm.totalKilo += val.KILO;
                  vm.totalSonuc += parseInt(sonuc);

                  vm.rowData[index] = {
                    isCreate: false,
                    KILO: val.KILO,
                    GROUPCODE: val.GROUPCODE,
                    SONUC: parseInt(sonuc),
                    CARIADT: val.CARIADT,
                    COMPANYID: val.COMPANYID,
                    IADE: val.IADE,
                    IHR: val.IHR,
                    KRITIKSTOK: parseInt(val.KRITIKSTOK),
                    QDEPOT: val.QDEPOT,
                    SATALSIP: val.SATALSIP,
                    SATIADE: val.SATIADE,
                    SATIS: val.SATIS,
                    SATSIP: val.SATSIP,
                    STOCKID: val.STOCKID,
                    STOCKNAME: val.STOCKNAME,
                    STOCKNO: val.STOCKNO,
                    VATSALES: val.VATSALES,
                    paketDeger: paketDeger,
                    sonFiyat:
                      isNaN(parseInt(fiyat)) == false
                        ? parseFloat(fiyat).toFixed(2)
                        : 0.0,
                    sonNetFiyat: (isNaN(parseInt(fiyat)) == false
                      ? parseFloat(fiyat).toFixed(2)
                      : 0.0) - (isNaN(parseInt(DISCOUNT1)) == false
                        ? parseFloat(DISCOUNT1).toFixed(2)
                        : 0.0) - (isNaN(parseInt(DISCOUNT2)) == false
                          ? parseFloat(DISCOUNT2).toFixed(2)
                          : 0.0) - (isNaN(parseInt(DISCOUNT3)) == false
                            ? parseFloat(DISCOUNT3).toFixed(2)
                            : 0.0),
                    fiyat: isNaN(parseInt(price)) == false
                      ? parseFloat(price).toFixed(2)
                      : 0.0,
                    IND1: isNaN(parseInt(DISCOUNT1)) == false
                      ? parseFloat(DISCOUNT1).toFixed(2)
                      : 0.0,
                    IND2: isNaN(parseInt(DISCOUNT2)) == false
                      ? parseFloat(DISCOUNT2).toFixed(2)
                      : 0.0,
                    IND3: isNaN(parseInt(DISCOUNT3)) == false
                      ? parseFloat(DISCOUNT3).toFixed(2)
                      : 0.0,
                    cariId: ACTIDD,
                    ACTID: ACTIDD,
                    cariAdi: ACTNAMEE
                  };
                  vm.totalPrice += parseFloat(vm.rowData[index].fiyat);
                });
                vm.rowData2 = vm.rowData;
                vm.ihtiyacOlanlarValidate = true;
                vm.query = "";
                vm.pinnedBottomRowData = vm.createData(1, "Bottom");
              } else {
                vs.notify({
                  title: "Hata",
                  text: "Liste getirilirken hata oluştu" + vm.veriler.error,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center"
                });
              }
              vm.ACTNAME = "";
              vm.ACTID = "";
              vm.ACTGROUP = "";
            } catch (error) {
              console.log(error);
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              vs.notify({
                title: "Hata",
                text: "Liste getirilirken hata oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      }
    },

    cellCellEditorParams(params) {
      const selectedId = params.data.STOCKID;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        STOCKID: selectedId,
        ACTID: this.ACTID,
        STOCKGROUP: params.data.GROUPCODE
      };
      var dizi = [];
      var veriler = [];
      soap.createClient(url, function (err, client) {
        client.INT_Ls_Stock_TalepStokSec(args, function (err, result) {
          if (result.INT_Ls_Stock_TalepStokSecResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            veriler = JSON.parse(result.INT_Ls_Stock_TalepStokSecResult);
            veriler.forEach((val, ind) => {
              dizi.push(val.PRICE.toString() + "/" + val.FTUR);
            });
          } catch (error) { }
        });
      });
      return {
        values: dizi,
        formatValue: value => `${value}`,
        cellHeight: 20
      };
    },
    createData(count, prefix) {
      var result = [];

      result.push({
        STOCKNO: "",
        STOCKNAME: "",
        IHR: "",
        CARIADT: "",
        IADE: "",
        SATIADE: "",
        SATALSIP: "",
        SATSIP: "",
        KRITIKSTOK: "",
        SATIS: "",
        QDEPOT: "",
        SONUC: this.totalSonuc,
        miktar: this.totalMiktar,
        KILO: this.totalKilo,
        cariAdi: "",
        sonFiyat: "",
        sonNetFiyat: "",
        fiyat: this.totalPrice,
        IND1: "",
        IND2: "",
        IND3: "",

      });

      return result;
    },
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("setSonucData", (par1, par2) => {
      this.setSonucData(par1, par2);
    });
    this.$root.$on(
      "satinalmaPlanlamaListForACT",
      (index, item, stokid, group) => {
        this.satinalmaPlanlamaListForACT(index, item, stokid, group);
      }
    );
  },
  beforeDestroy() {
    this.$root.$off("setSonucData");
    this.$root.$off("satinalmaPlanlamaListForACT");
  },
  created() {
    this.$store.commit("account/SATINALMA_FIYAT", "");

    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.rowSelection = "multiple";

    this.getPlanlamaList();
    this.allActInformation();
    this.rowClassRules = {
      // row style function
      'bg-danger': (params) => {
        var numSickDays = params.data.isCreate;
        return numSickDays == true;
      },
      'bg-success': (params) => {
        var numSickDays = params.data.isCreate;
        return numSickDays == "success";
      },
    };
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 150,
        field: "",
        cellRendererFramework: "PlanlamaButon"
      },
      {
        headerName: "Stok Kodu",
        field: "STOCKNO",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        filterParams: { caseSensitive: true, defaultOption: "startsWith" }
      },
      {
        headerName: "Stok Adı",
        filter: "agSetColumnFilter",
        sortable: true,
        filter: true,
        field: "STOCKNAME",
        filter: "agTextColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        width: 300,
        filterParams: { caseSensitive: true, defaultOption: "startsWith" }
      },
      {
        headerName: "Detay",

        children: [
          {
            headerName: "İhr %",
            field: "IHR",
            sortable: true,
            width: 100,
            filter: "agNumberColumnFilter",
            cellRenderer: "SatPlanlamaIhrCellGorunum",
            type: "rightAligned",
            cellStyle: params => {
              if (isNaN(parseInt(params.value)) == false) {
                //mark police cells as red
                if (params.value.toFixed(0) > 50)
                  return { backgroundColor: "#f29899" };
              }
              return null;
            }
          },
          {
            headerName: "Cari",
            field: "CARIADT",
            sortable: true,
            filter: true,
            width: 100,

            filter: "agNumberColumnFilter",
            columnGroupShow: "open",
            type: "rightAligned",
            cellStyle: params => {
              if (params.value === 1) {
                //mark police cells as red
                return { backgroundColor: "#f29899" };
              }
              return null;
            }
          },
          {
            headerName: "Al İade",
            field: "IADE",
            sortable: true,
            width: 100,

            filter: "agNumberColumnFilter",
            type: "rightAligned",
            columnGroupShow: "open",
            cellStyle: params => {
              if (params.value > 0) {
                //mark police cells as red
                return { backgroundColor: "#f29899" };
              }
              return null;
            }
          },
          {
            headerName: "Sat İade",
            field: "SATIADE",
            width: 100,
            sortable: true,
            filter: "agNumberColumnFilter",
            type: "rightAligned",
            columnGroupShow: "open",
            cellStyle: params => {
              if (params.value > 0) {
                //mark police cells as red
                return { backgroundColor: "#f29899" };
              }
              return null;
            }
          },

          {
            headerName: "Al. Sip",
            field: "SATALSIP",
            width: 100,
            sortable: true,
            filter: "agNumberColumnFilter",
            type: "rightAligned",
            columnGroupShow: "open",

            cellStyle: params => {
              if (params.value > 0) {
                //mark police cells as red
                return { backgroundColor: "#f29899" };
              }
              return null;
            }
          },
          {
            headerName: "Sat. Sip",
            field: "SATSIP",
            width: 100,
            sortable: true,
            filter: "agNumberColumnFilter",
            type: "rightAligned",
            columnGroupShow: "open",
            cellStyle: params => {
              if (params.value > 0) {
                //mark police cells as red
                return { backgroundColor: "#f29899" };
              }
              return null;
            }
          },
          {
            headerName: "Kritik Stok",
            field: "KRITIKSTOK",
            width: 100,
            sortable: true,
            filter: "agNumberColumnFilter",
            type: "rightAligned",
            columnGroupShow: "open"
          },
          {
            headerName: "Satış",
            field: "SATIS",
            width: 100,
            sortable: true,
            filter: "agNumberColumnFilter",
            type: "rightAligned",
            columnGroupShow: "open"
          }
        ]
      },
      {
        headerName: "Depo",
        field: "QDEPOT",
        sortable: true,
        type: "rightAligned",
        filter: "agNumberColumnFilter"
      },
      {
        headerName: "Sonuç",
        field: "SONUC",
        sortable: true,
        type: "rightAligned",
        filter: "agNumberColumnFilter"
      },
      {
        sortable: true,
        filter: "agNumberColumnFilter",
        cellRenderer: "SatPlanlamaMiktarCellRenderer",
        filter: true
      },
      {
        headerName: "Miktar",
        field: "miktar",
        sortable: true,
        filter: "agNumberColumnFilter",
        editable: true,
        filter: true
      },
      {
        headerName: "Kilo",
        field: "KILO",
        sortable: true,
        filter: "agNumberColumnFilter",
        filter: true
      },

      {
        headerName: "Cari Id",
        field: "ACTID",
        sortable: true,
        filter: "agTextColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        hide: true,
        autoHeight: true,
        editable: true,
        filter: true
      },
      {
        field: "isCreate",
        hide: true,
      },

      {
        headerName: "Cari Adı",
        field: "cariAdi",
        sortable: true,
        filter: "agTextColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        editable: true,
        filter: true,
        cellEditorSelector: params => {
          return {
            component: "CariAutosuggest",
            popup: true
          };
        }
      },
      {
        headerName: "Son Alış Fiyatı",
        field: "sonFiyat",
        sortable: true,
        filter: "agNumberColumnFilter",
        editable: true,
        filter: true
        //  cellEditorPopup: true,
        /* cellEditorSelector: params => {
          return {
            component: "SatinalmaPlanlamaFiyatModal",
            popup: true
          };
        }*/
      },
      {
        headerName: "Şuanki Net Alış",
        field: "sonNetFiyat",
        sortable: true,
        filter: "agNumberColumnFilter",
        editable: true,
        filter: true
        //  cellEditorPopup: true,
        /* cellEditorSelector: params => {
          return {
            component: "SatinalmaPlanlamaFiyatModal",
            popup: true
          };
        }*/
      },
      {
        headerName: "Fiyat",
        field: "fiyat",
        sortable: true,
        filter: "agNumberColumnFilter",
        editable: true,
        filter: true
        //  cellEditorPopup: true,
        /* cellEditorSelector: params => {
          return {
            component: "SatinalmaPlanlamaFiyatModal",
            popup: true
          };
        }*/
      },

      {
        headerName: "İsk 1",
        field: "IND1",
        sortable: true,
        filter: "agNumberColumnFilter",
        editable: true,
        filter: true
      },
      {
        headerName: "İsk 2",
        field: "IND2",
        sortable: true,
        filter: "agNumberColumnFilter",
        editable: true,
        filter: true
      },
      {
        headerName: "İsk 3",
        field: "IND3",
        sortable: true,
        filter: "agNumberColumnFilter",
        editable: true,
        filter: true
      }
    ];
  }
};
</script>
<style lang="scss">
table.vgt-table {
  font-size: small;
}

.bg-success {
  background-color: #f4f9c4 !important;

}

.bg-danger {
  background-color: #F8CBCC !important;

}

[dir] #autosuggest__input {
  padding: 4px;
}

/*
[dir] .btn-check:checked + .btn-primary,
[dir] .btn-check:active + .btn-primary,
[dir] .btn-primary:active,
[dir] .btn-primary.active,
[dir] .show > .btn-primary.dropdown-toggle {
  background-color: #ea5455;
  border-color: #ea5455;
}
[dir] .btn-check:checked + .btn-primary,
[dir] .btn-check:active + .btn-primary,
[dir] .btn-primary:active,
[dir] .btn-primary.active,
[dir] .show > .btn-primary.dropdown-toggle {
  background-color: #ea5455;
  border-color: #ea5455;
}
[dir] .btn-primary:hover {
  background-color: #ea5455;
  border-color: #ea5455;
}*/
[dir] .btn-danger {
  background-color: #ea5455;
  border-color: #ea5455;
}

[dir] .btn-group button {
  padding: 0.85rem 1rem !important;
}
</style>
